import { Form, SubmitButton } from '@/components';
import { FundBusinessUpdateFormSchema } from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import type { FundBusinessFormValues } from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { FormProvider, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FundBusinessTitleField } from '../fields/FundBusinessTitleField';
import { FundBusinessAmountFields } from '../fields/fund-business-amount-fields/FundBusinessAmountFields';

type Props = {
  initialValues?: FundBusinessFormValues;
  onSubmit: (values: FundBusinessFormValues) => void;
  fiscalYear: number;
};

export const ActualResultsForm: FC<Props> = ({
  initialValues,
  onSubmit,
  fiscalYear,
}) => {
  const { t } = useTranslation();

  const formMethods = useForm<FundBusinessFormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(FundBusinessUpdateFormSchema),
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isDirty, isSubmitSuccessful },
  } = formMethods;

  const { fields } = useFieldArray({ name: 'performances', control });

  return (
    <FormProvider {...formMethods}>
      <Form
        leavePageAlertCondition={{
          isDirty,
          isSubmitting,
          isSubmitSuccessful,
        }}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <FundBusinessTitleField />
        <FundBusinessAmountFields fiscalYear={fiscalYear} fields={fields} />
        <SubmitButton
          text={t('save')}
          disabled={!isDirty}
          loading={isSubmitting}
        />
      </Form>
    </FormProvider>
  );
};
